module.exports = __webpack_public_path__ + "img/pause.a95ce5d2.svg";